var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from 'react';
import { defaultGroupProps } from './defaults';
import { Checkbox } from './Checkbox';
var CheckboxGroup = /** @class */ (function (_super) {
    __extends(CheckboxGroup, _super);
    function CheckboxGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.handleCurrList = function (e) {
            var list = [];
            _this.state.childList.forEach(function (item) {
                if (e.target.value === item.currValue) {
                    item.checked = e.target.checked;
                }
                if (item.checked) {
                    list.push(item.currValue);
                }
            });
            _this.props.onChange && _this.props.onChange(list);
        };
        _this.renderReactChildren = function () {
            var disabled = _this.props.disabled;
            return React.Children.map(_this.props.children, function (child, index) {
                var childElement = child;
                return React.cloneElement(childElement, {
                    disabled: disabled,
                    value: childElement.props.children,
                    onChange: _this.handleCurrList,
                });
            });
        };
        _this.renderListChildren = function () {
            var _a = _this.props, options = _a.options, value = _a.value, defaultValue = _a.defaultValue, disabled = _a.disabled, className = _a.className;
            return options.map(function (item) {
                return (React.createElement(Checkbox, { className: className, key: item, value: item, disabled: disabled, checked: value.includes(item), onChange: function (e) {
                        _this.handleCurrList(e);
                    } }, item));
            });
        };
        _this.state = {
            childList: [],
        };
        return _this;
    }
    CheckboxGroup.prototype.componentDidMount = function () {
        if (React.Children.count(this.props.children)) {
            //说明是带有vnode
            this.initChildNode();
        }
        else {
            this.initChildList(this.props.value);
        }
    };
    CheckboxGroup.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.value !== this.props.value) {
            this.initChildList(nextProps.value);
        }
    };
    CheckboxGroup.prototype.initChildNode = function () {
        var _this = this;
        var childNode = [];
        React.Children.map(this.props.children, function (child, index) {
            var childElement = child;
            childNode.push({
                currValue: childElement.props.children,
                checked: childElement.props.defaultChecked,
            });
            _this.setState({
                childList: childNode,
            });
        });
    };
    CheckboxGroup.prototype.initChildList = function (handleValue) {
        var childList = [];
        this.props.options.forEach(function (item) {
            childList.push({
                checked: handleValue.includes(item),
                currValue: item,
            });
        });
        this.setState({
            childList: childList,
        });
    };
    CheckboxGroup.prototype.render = function () {
        if (React.Children.count(this.props.children) > 0) {
            return this.renderReactChildren();
        }
        else {
            return this.renderListChildren();
        }
    };
    CheckboxGroup.defaultProps = defaultGroupProps;
    CheckboxGroup.NAME = 'checkbox-group';
    CheckboxGroup.displayName = 'CheckboxGroup';
    return CheckboxGroup;
}(PureComponent));
export { CheckboxGroup };
